'use client';

import { MotionConfig } from 'framer-motion';
import type { ReactNode } from 'react';

/**
 * Applies framer-motion's "user" reduced-motion policy to the whole
 * landing page: transform/layout animations snap to their final state
 * for users who have enabled reduced motion at the OS level, while
 * opacity fades (which are generally safe) still play.
 */
export function LandingMotionConfig({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
